import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs.components'
import TransitionAgencyHeroSection from './components/TransitionAgencyHeroSection/TransitionAgencyHeroSection.component'
import TransitionAgencyVideoSection from './components/TransitionAgencyVideoSection/TransitionAgencyVideoSection.component'
import WhyPartnerWithUsabg from './components/WhyPartnerWithUsabg/WhyPartnerWithUsabg.component'
import YourAgencysFuture from './components/YourAgencysFuture/YourAgencysFuture.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './TransitionYourAgency.page.scss'

class TransitionYourAgencyPage extends React.Component {
  componentDidMount() {
    document.title = 'Transition Your Agency | Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='TransitionYourAgencyPage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Transition Your Agency' }]} />
        <TransitionAgencyHeroSection />
        <TransitionAgencyVideoSection />
        <WhyPartnerWithUsabg />
        <YourAgencysFuture />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default TransitionYourAgencyPage
